import './styles.scss'

const German = ({ onClick }) => {
  let languageClass = 'language-item-de'

  return (
    <div className={languageClass}>
      <button onClick={() => onClick()}></button>
    </div>
  )
}

export default German
